import { InfoIcon } from '@rsos/assets/icons';
import { InfoBanner } from './TransferToAgencyModal.styles';

function TransferInfoBanner() {
  return (
    <InfoBanner>
      <InfoIcon width={14} height={14} color="secondaryText" />
      You will stay in the chat after you transfer until you choose to leave.
    </InfoBanner>
  );
}

export default TransferInfoBanner;
